module.exports = __webpack_public_path__ + "static/media/preview.755ea62a.png";